import { render, staticRenderFns } from "./PlantVarietyNoteTypeForm.vue?vue&type=template&id=b1ab12c8&"
import script from "./PlantVarietyNoteTypeForm.vue?vue&type=script&lang=js&"
export * from "./PlantVarietyNoteTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./PlantVarietyNoteTypeForm.vue?vue&type=style&index=0&id=b1ab12c8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports